export const formatarSlaHoras = (minutos) => {
  const total = Number(minutos)
  if (!Number.isFinite(total) || total <= 0) return '-'

  const dias = Math.floor(total / 1440)
  const horas = Math.floor((total % 1440) / 60)
  const resto = total % 60

  return [
    dias && `${dias}d`,
    horas && `${horas}h`,
    resto && `${resto}min`
  ].filter(Boolean).join(' ')
}
